import { useContext } from 'react';

import { DebtConContext } from '@src/app/contexts/DebtCon';
import EligibilityLayout from '@src/ui/layouts/EligibilityLayout';
import NewDebtInputView from '@src/ui/views/debtCon/DebtInput/NewDebtInputView';

const NewDebtInput = () => {
    const { loading } = useContext(DebtConContext);

    return (
        <EligibilityLayout loading={loading} debtInputPage>
            <NewDebtInputView />
        </EligibilityLayout>
    );
};

export default NewDebtInput;
